"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlankPosition = exports.PositionRequestDTOSchema = exports.PositionDTO = exports.PositionDTOSchema = exports.PositionSchema = exports.PositionBaseSchema = void 0;
var zod_1 = require("zod");
var CommonMongoModelFields_1 = require("./lib/CommonMongoModelFields");
exports.PositionBaseSchema = zod_1.z.object({
    Yacht: zod_1.z.string().min(1, 'Yacht Name is required'),
    YachtType: zod_1.z.enum(['MY', 'SY']),
    YachtIMO: zod_1.z.string().nullish(),
    Positions: zod_1.z.array(zod_1.z.string()),
    StartYear: zod_1.z.coerce.number().min(1900, { message: 'Invalid start year' }),
    EndYear: zod_1.z.coerce.number().optional(),
});
exports.PositionSchema = exports.PositionBaseSchema.extend(CommonMongoModelFields_1.CommonMongoModelFields);
exports.PositionDTOSchema = exports.PositionSchema.extend(CommonMongoModelFields_1.CommonModelDTOFields);
exports.PositionDTO = {
    convertFromModel: function (model) {
        var dto = {
            _id: model._id.toString(),
            createdAt: model.createdAt,
            updatedAt: model.updatedAt,
            Yacht: model.Yacht,
            YachtType: model.YachtType,
            YachtIMO: model.YachtIMO,
            Positions: model.Positions,
            StartYear: model.StartYear,
            EndYear: model.EndYear,
        };
        return dto;
    },
};
exports.PositionRequestDTOSchema = exports.PositionDTOSchema.extend(CommonMongoModelFields_1.CommonModelRequestDTOFields).refine(function (_a) {
    var _b = _a.EndYear, EndYear = _b === void 0 ? 0 : _b, StartYear = _a.StartYear;
    return EndYear === 0 || StartYear <= EndYear;
}, {
    message: 'The Position cannot start after it ended',
    path: ['StartYear'],
});
exports.BlankPosition = {
    Yacht: '',
    Positions: [],
    StartYear: new Date().getFullYear(),
    YachtType: 'MY',
    YachtIMO: '',
};
//# sourceMappingURL=Position.js.map